import styled from 'styled-components';

export const CancellationTypeDescription = styled.div`
  max-width: 300px;
`;

export const CancellationPenaltyContainer = styled.div`
  padding: 16px 24px;
  background: ${({ theme }) => theme.colors.background1};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.shapes.borderRadius};

  span {
    color: ${({ theme }) => theme.colors.text1};
  }

  .ant-btn span {
    color: inherit;
  }
`;

export const CancellationPenaltyContent = styled.div`
  display: grid;
  place-items: center;

  .cancellation-penalty-value {
    padding: 8px 16px;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  .cancellation-penalty-loyalty {
    margin: 0;
    font-size: 0.85rem;
    strong {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .cancellation-penalty-not-found {
    p {
      margin: 0;
      font-weight: bold;
      font-size: 0.9rem;
    }

    span {
      font-size: 0.85rem;
    }
  }
`;
